<template>
  <div>
    <div class="con-list f-clearfix live-card">
      <ul class="index-course f-clearfix">
        <li v-for="(item, index) in tableList" :key="index" :title="item.name">
          <a :href="item.linkUrl" target="_blank">
            <div class="item-img">
              <img
                v-img.lazy="imgUrl + item.coverUrl"
                :alt="item.title"
                :title="item.title"
              />
              <div class="item-live-tags-b"></div>
              <div class="item-live-tags" v-if="item.dateStatus != 3">
                直播时间：{{ item.startDate }} {{ item.startTime }}-{{
                  item.endTime
                }}
              </div>
              <div class="item-live-tags" v-else>已结束</div>
            </div>
            <h3>{{ item.title }}</h3>
            <div class="f-clearfix">
              <span
                class="item-live item-live-name"
                :title="item.schoolName + ' | ' + item.teacherName"
                >{{ item.schoolName }} | {{ item.teacherName }}</span
              >
            </div>
          </a>
        </li>
      </ul>
      <!-- <div class="item-flex"></div> -->
      <div class="icon-btn icon-btn-left" @click="pageLeft('left')">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="icon-btn icon-btn-right" @click="pageLeft('right')">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      liveList: [],
      pageFlag: 1,
      tableList: [],
      imgUrl: this.$setting.fdsDomain,
      pageList: {
        pageNo: 1,
        pageSize: 4,
        total: 0,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    pageLeft(val) {
      if (val == "left") {
        if (this.pageFlag > 1) {
          this.tableList = [];
          let item = [];
          this.pageFlag--;
          for (let i = (this.pageFlag - 1) * 4; i < this.pageFlag * 4; i++) {
            item.push(this.liveList[i]);
          }
          this.tableList = item;
        }
      } else {
        if (this.pageFlag < Math.ceil(this.liveList.length / 4)) {
          this.tableList = [];
          let item = [];
          for (let j = this.pageFlag * 4; j < (this.pageFlag + 1) * 4; j++) {
            if (j < this.liveList.length) {
              item.push(this.liveList[j]);
            }
          }
          this.tableList = item;
          this.pageFlag++;
        }
      }
    },
    getList() {
      let par = {
        pageSize: 9999,
        currentPage: this.pageList.pageNo,
        status: 0,
      };
      this.$http
        .get("/api/manage/live/pageList", { params: par })
        .then((res) => {
          let item = res.data.records;
          if (item.length > 0) {
            for (let i = 0; i < item.length; i++) {
              let dateFlag = new Date().getTime();
              let dateStatus = 0;
              let str1 = (
                item[i].startDate +
                " " +
                item[i].startTime
              ).toString();
              str1 = str1.replace(/-/g, "/");
              let oDate1 = new Date(str1).getTime();
              let str2 = (item[i].startDate + " " + item[i].endTime).toString();
              str2 = str2.replace(/-/g, "/");
              let oDate2 = new Date(str2).getTime();
              if (dateFlag < oDate1) {
                dateStatus = 2;
              } else if (oDate1 < dateFlag && dateFlag < oDate2) {
                dateStatus = 1;
              } else if (oDate2 < dateFlag) {
                dateStatus = 3;
              }
              item[i].dateStatus = dateStatus;
            }
          }
          this.liveList = item;

          for (let i = 0; i < 4; i++) {
            if (i < this.liveList.length) {
              this.tableList.push(this.liveList[i]);
            }
          }
          this.$emit("getlive", this.liveList.length > 0);
        })
        .catch((msg) => {
          console.log(msg);
        });
    },
  },
};
</script>
<style lang="scss">
.live-card {
  display: flex;
  height: 270px;
  justify-content: space-between;
  border-radius: 4px;
  position: relative;
  .index-course {
    width: 100%;
    margin-top: 50px;
  }
  h2 {
    flex: 1;
    max-width: 180px;
    min-width: 180px;
    padding: 0 20px;
    font-size: 18px;
    color: #333;
  }
  .item-flex {
    flex: 1;
    min-width: 70px;
    max-width: 70px;
  }
  .icon-btn {
    position: absolute;
    top: 80px;
    font-size: 32px;
    color: #fff;
    line-height: 60px;
    cursor: pointer;
    i {
      font-weight: bold;
      background: #e5e6ebff;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
    }
    &:hover {
      color: #3685fd;
    }
  }
  .icon-btn-left {
    left: -60px;
  }
  .icon-btn-right {
    right: -60px;
  }

  .index-course {
    overflow: hidden;
    margin-top: 30px;
    :nth-child(4n) {
      margin-right: 0px;
    }
    li {
      float: left;
      width: 280px;
      margin-right: 26px;
      margin-bottom: 26px;
      a:hover {
        color: #2f3440;
      }
      .item-img {
        width: 280px;
        height: 160px;
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          transition: all 0.2s ease-in-out;
        }
        .item-live-tags-b {
          position: absolute;
          bottom: 0px;
          left: 0px;
          width: 100%;
          height: 30px;
          background: #00000077;
          z-index: 1;
        }

        .item-live-tags {
          position: absolute;
          bottom: 0px;
          left: 0px;
          width: 100%;
          height: 30px;
          text-align: center;
          z-index: 10;
          color: #fff;
          line-height: 30px;
          font-size: 14px;
        }
      }
      h3 {
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 30px;
      }
      div {
        // height: 40px;
        // line-height: 40px;
        span {
          color: #777;
          font-size: 12px;
        }
        .item-live {
          float: left;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .item-edu {
          float: right;
          text-align: right;
        }
      }
      &:hover {
        cursor: pointer;
        img {
          opacity: 0.8;
          transform: scale(1.1);
          transition: all 0.4s ease-in-out;
        }
      }
    }
  }
}
</style>
